import BasicCertificationsProducersRoutes from "./basic_certifications_producers";
import QueryFormatsRoutes from "./query_formats.js"

export default [
  ...BasicCertificationsProducersRoutes,
  ...QueryFormatsRoutes
];
